import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

export const isProductSoldOut = (
  product: Pick<IProduct, 'id' | 'soldOut'> | null | undefined,
  soldOutIds: number[] = []
): boolean =>
  Boolean(product?.soldOut) ||
  (product?.id !== undefined && soldOutIds.includes(product.id))

export const findSoldOutLines = (
  bucketProducts: IBucketProduct[] = [],
  soldOutIds: number[] = []
): IBucketProduct[] =>
  soldOutIds.length
    ? bucketProducts.filter((line) => soldOutIds.includes(line.productId))
    : []
